import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useBackerApi } from '../../api';
import { PropertyValue } from '../../properties/properties.types';
import { backerKeys } from '../../query-key-factory';

const useUpdateBackerConsumerProperties = ({ causeId }: { causeId: string }) => {
  const BackerApi = useBackerApi();
  const queryClient = useQueryClient();
  const causeQuery = `cause_id=${causeId}`;

  const updateBackerConsumerProperties = async ({
    properties,
  }: {
    properties: Record<string, string>;
  }) => {
    const { data } = await BackerApi.put<{ values: PropertyValue[] }>(
      `consumer/properties?${causeQuery}`,
      { properties }
    );
    return data;
  };

  return useMutation({
    mutationFn: updateBackerConsumerProperties,
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: backerKeys.consumer.properties.id(causeId).all,
      });
    },
  });
};

export { useUpdateBackerConsumerProperties };
